export interface ArticleData {
  slug: string;
  title: string;
  excerpt: string;
  imageSeq: string;
  readTime: string;
  date: string;
  category?: string;
}

export const featuredArticles: ArticleData[] = [
  {
    slug: "what-is-litbuy-spreadsheet",
    title: "What Is a LitBuy Spreadsheet? Complete Beginner Guide",
    excerpt: "Discover everything you need to know about LitBuy spreadsheets — how they work, why shoppers love them, and how they can save you hours of manual searching across thousands of product listings.",
    imageSeq: "art-what-is",
    readTime: "8 min read",
    date: "June 15, 2026",
  },
  {
    slug: "best-litbuy-spreadsheet-beginners",
    title: "Best LitBuy Spreadsheet for Beginners in 2026",
    excerpt: "New to LitBuy spreadsheets? We compare the top spreadsheet options for beginners, covering ease of use, feature sets, update frequency, and overall value to help you start shopping smarter today.",
    imageSeq: "art-beginners",
    readTime: "7 min read",
    date: "June 18, 2026",
  },
  {
    slug: "how-to-use-litbuy-spreadsheet",
    title: "How to Use a LitBuy Spreadsheet Step by Step",
    excerpt: "A complete walkthrough on setting up and navigating your first LitBuy spreadsheet. Learn to filter sellers, compare prices, track QC photos, and organize your haul like a pro.",
    imageSeq: "art-howto",
    readTime: "10 min read",
    date: "June 20, 2026",
  },
];

export const latestGuides: ArticleData[] = [
  {
    slug: "litbuy-spreadsheet-vs-manual",
    title: "LitBuy Spreadsheet vs Manual Shopping",
    excerpt: "Which method saves more time and money? A data-driven comparison of using spreadsheets versus searching manually on LitBuy.",
    imageSeq: "guide-vs",
    readTime: "6 min read",
  },
  {
    slug: "litbuy-spreadsheet-safety-guide",
    title: "LitBuy Spreadsheet Safety Guide 2026",
    excerpt: "Stay safe while shopping with spreadsheets. Learn how to spot red flags, verify seller credibility, and avoid common scams on the platform.",
    imageSeq: "guide-safety",
    readTime: "9 min read",
  },
  {
    slug: "litbuy-spreadsheet-buying-tips",
    title: "Top 10 LitBuy Spreadsheet Buying Tips",
    excerpt: "Expert tips to maximize your spreadsheet experience — from finding trusted sellers to getting the best deals on sought-after items.",
    imageSeq: "guide-tips",
    readTime: "7 min read",
  },
];

export const seoArticles: ArticleData[] = [
  {
    slug: "best-categories-litbuy-spreadsheet",
    title: "Best Categories Inside LitBuy Spreadsheets Ranked",
    excerpt: "A comprehensive ranking of the most popular and useful product categories found inside LitBuy spreadsheets, from shoes and clothing to accessories and beyond.",
    imageSeq: "seo-categories",
    readTime: "9 min read",
    date: "June 10, 2026",
    category: "Guides",
  },
  {
    slug: "find-trusted-sellers-litbuy-spreadsheet",
    title: "How to Find Trusted Sellers Using a LitBuy Spreadsheet",
    excerpt: "Learn the proven methods for identifying reliable sellers through spreadsheet data — seller ratings, community feedback, transaction history, and red flag detection.",
    imageSeq: "seo-sellers",
    readTime: "8 min read",
    date: "June 12, 2026",
    category: "Guides",
  },
  {
    slug: "litbuy-spreadsheet-for-shoes",
    title: "LitBuy Spreadsheet for Shoes: The Ultimate Sneaker Guide",
    excerpt: "Everything sneakerheads need to know about using LitBuy spreadsheets to find the best shoe deals, compare batches, and discover hidden gems across multiple sellers.",
    imageSeq: "seo-shoes",
    readTime: "7 min read",
    date: "June 14, 2026",
    category: "Categories",
  },
  {
    slug: "litbuy-spreadsheet-for-clothing",
    title: "LitBuy Spreadsheet for Clothing: Hoodies, Tees and More",
    excerpt: "How to navigate clothing categories in LitBuy spreadsheets — find the best hoodies, t-shirts, jackets, and streetwear from top-rated sellers with verified quality.",
    imageSeq: "seo-clothing",
    readTime: "8 min read",
    date: "June 16, 2026",
    category: "Categories",
  },
  {
    slug: "litbuy-spreadsheet-for-bags-accessories",
    title: "LitBuy Spreadsheet for Bags and Accessories",
    excerpt: "Discover how LitBuy spreadsheets organize bags, belts, perfumes, and accessories — making it easy to compare styles, prices, and seller reliability in one place.",
    imageSeq: "seo-bags",
    readTime: "6 min read",
    date: "June 17, 2026",
    category: "Categories",
  },
  {
    slug: "litbuy-spreadsheet-red-flags",
    title: "LitBuy Spreadsheet Red Flags You Should Never Ignore",
    excerpt: "Protect yourself from scams and low-quality products. Learn the warning signs to watch for when browsing LitBuy spreadsheets — from fake reviews to suspicious pricing.",
    imageSeq: "seo-redflags",
    readTime: "7 min read",
    date: "June 19, 2026",
    category: "Safety",
  },
  {
    slug: "common-mistakes-litbuy-spreadsheet",
    title: "7 Common Mistakes New LitBuy Spreadsheet Users Make",
    excerpt: "Avoid the pitfalls that trip up most beginners. From overlooking seller ratings to ignoring update dates, these mistakes can cost you time and money.",
    imageSeq: "seo-mistakes",
    readTime: "6 min read",
    date: "June 20, 2026",
    category: "Guides",
  },
  {
    slug: "best-alternatives-litbuy-spreadsheet",
    title: "Best Alternatives to LitBuy Spreadsheet in 2026",
    excerpt: "A balanced comparison of LitBuy spreadsheets versus alternative shopping organization methods — including browser extensions, apps, and manual tracking systems.",
    imageSeq: "seo-alternatives",
    readTime: "8 min read",
    date: "June 21, 2026",
    category: "Comparisons",
  },
  {
    slug: "complete-litbuy-spreadsheet-guide-2026",
    title: "The Complete LitBuy Spreadsheet Guide 2026 — Pillar Content",
    excerpt: "The ultimate pillar guide covering everything about LitBuy spreadsheets — from beginner basics to advanced strategies, safety protocols, and category deep dives.",
    imageSeq: "seo-complete",
    readTime: "15 min read",
    date: "June 22, 2026",
    category: "Guides",
  },
];

export const shoppingGuideArticle: ArticleData = {
  slug: "shopping-guide-litbuy-spreadsheet",
  title: "Shopping Guide: How to Use LitBuy Spreadsheet Like a Pro",
  excerpt: "Your complete shopping guide for navigating LitBuy spreadsheets — from choosing categories and vetting sellers to building your haul and checking out safely.",
  imageSeq: "guide-shopping",
  readTime: "12 min read",
  date: "June 20, 2026",
  category: "Shopping Guide",
};